import { useAction, useAtom } from "@reatom/npm-react";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { RoutesPaths } from "src/routes/RoutesPaths";

import { notificationAtom } from "../../store/notification";
import { resendCodeRequest } from "../../store/resendCodeRequest";
import { verify } from "../../store/verify";

export const useVerification = () => {
  const setNotification = useAction(notificationAtom);
  const [isLoading] = useAtom(verify.isLoadingAtom);
  const verifyRequest = useAction(verify);
  const resendCode = useAction(resendCodeRequest);
  const navigate = useNavigate();
  const location = useLocation();

  // Получаемся state с предыдущего роута
  const emailLocation = location.state?.email;

  // Есть два способа верификации, можно вписать код из письма, либо перейти по ссылке в письме, здесь мы получаем код из ссылки
  const [searchParams] = useSearchParams();
  const codeParams = searchParams.get("code");
  const emailParams = searchParams.get("email");

  const [code, setCode] = useState(codeParams);
  const [email] = useState(emailLocation || emailParams);

  const accountVerify = useCallback(
    async (code?: string | null, email?: string | null) => {
      if (!code || !email) return;

      await verifyRequest(code, email)
        .then(() => {
          setNotification({
            theme: "success",
            message: "Успешная верификация",
          });

          // Есил пользователь прошел верификацию, то редиректим его на форму с доп информацией
          navigate(RoutesPaths.AUTH.FINALY_REG);
        })
        .catch(() => {
          setNotification({
            theme: "danger",
            message:
              "Произошла ошибка во время верификации. Попробуйте ещё раз",
          });
        });
    },
    [navigate, setNotification, verifyRequest],
  );

  useEffect(() => {
    // Если пользователь перешел по ссылке, то сразу его верифицируем
    if (codeParams) {
      accountVerify(codeParams);
    }
  }, [accountVerify, codeParams]);

  return { code, setCode, email, accountVerify, resendCode, isLoading };
};
